import i18n from "../i18n";

// The API may return JSON, plain text, or an HTML error page. Only pass on
// something that reads like a message — never markup, a stack trace or a
// machine code such as "internal_error" or "unauthorized".
export const readError = async (res) => {
  const raw = await res.text().catch(() => "");
  let message = raw;
  try {
    const parsed = JSON.parse(raw);
    message = parsed.message || parsed.error || "";
  } catch {
    /* not JSON — keep raw */
  }
  if (typeof message !== "string") message = "";
  message = message.trim();
  if (/^</.test(message)) message = "";                 // HTML error page
  if (message.length > 200) message = "";               // stack trace or data dump
  if (/^[a-z][a-z0-9_]*$/.test(message)) message = "";  // machine code, e.g. internal_error
  if (message) return message;
  console.error("API error:", res.status, raw.slice(0, 200));
  return i18n.t("errors.generic");
};